var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0835 13.7032V6.29609C7.0835 6.07609 7.15884 5.89554 7.30954 5.75443C7.46009 5.61345 7.63586 5.54297 7.83683 5.54297C7.90086 5.54297 7.96704 5.55207 8.03537 5.57026C8.10384 5.58832 8.17009 5.61554 8.23412 5.65193L14.0641 9.36338C14.1786 9.44144 14.2643 9.53491 14.3214 9.6438C14.3786 9.75283 14.4072 9.87144 14.4072 9.99964C14.4072 10.1278 14.3786 10.2464 14.3214 10.3555C14.2643 10.4644 14.1786 10.5578 14.0641 10.6359L8.23412 14.3473C8.17009 14.3837 8.10384 14.411 8.03537 14.429C7.96704 14.4472 7.90086 14.4563 7.83683 14.4563C7.63586 14.4563 7.46009 14.3858 7.30954 14.2448C7.15884 14.1037 7.0835 13.9232 7.0835 13.7032ZM8.3335 12.7913L12.7245 9.99964L8.3335 7.20797V12.7913Z",
    fill: "#304674"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardIcon);
export default __webpack_public_path__ + "static/media/forward-icon.e4c777568514f6f8ca045330bfdccc26.svg";
export { ForwardRef as ReactComponent };